<template>
  <section v-on:click="sectionClicked"
    :class="{pagePreview: !loading && page, scrolled: scrolled}">
    <Header ref="header" :class="{scrolled: scrolled}"/>
    <div class="previewInfo" v-if="!loading && page" :class="{ok: ok}">
      <span>This is preview page and can not be open by public viewer</span>
    </div>
    <div class="loadingFull" v-if="loading"></div>
    <NotFound v-else-if="!page"></NotFound>
    <Page :page="page" :breadcrumb="false"/>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Page from '@/components/Page.vue';
import Footer from '@/components/Footer.vue';
import NotFound from '@/components/NotFound.vue';

export default {
  name: 'pagePreview',
  components: {
    Header,
    Page,
    Footer,
    NotFound,
  },
  data() {
    return {
      loading: true,
      scrolled: false,
      page: null,
      ok: false,
    };
  },
  computed: {},
  methods: {
    doNothing() {},
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    /**
     * Validate language
     *
     */
    if (!this.$route.params.lang) {
      let langCode = window.navigator.userLanguage || window.navigator.language;
      langCode = (langCode === 'id-ID') ? 'id' : 'en';
      const countryCode = (langCode === 'id') ? 'id' : 'us';
      window.location.href = `/${langCode}-${countryCode}`;
    }

    /**
     * Get preview page
     *
     */
    const { params } = this.$route;
    this.$http.get(this.$config.uri(`page/detail/${params.code}?sign=${params.sign}`)).then((r) => {
      this.loading = false;
      this.page = r.data.status === 200 ? r.data.data : null;
      setTimeout(() => {
        this.ok = true;
      }, 100);
    });
  },
};
</script>

<style scoped lang="scss">
.pagePreview{
  // padding-top: 40px;
}
.previewInfo{
  // background-color: yellow;
  background-image: linear-gradient(45deg, yellow, transparent);
  position: fixed;
  top: 74px; left: 0; right: 0;
  color: #000;
  z-index: 991;
  display: flex;
  align-items: center;
  padding-left: 120px;
  height: 40px;
  &.ok{
    transition: all .3s ease;
  }
  span{
    padding-left: 30px;
    position: relative;
    &:before{
      content: "";
      position: absolute;
      left: 0; top: 50%;
      transform: translateY(-50%);
      margin-top: -2px;
      width: 20px; height: 20px;
      background-image: url(../assets/private.png);
      background-size: 18px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  @media (max-width: 1480px) {
    top: 64px;
    padding-left: 80px;
  }
  @media (max-width: 1240px) {
    padding-left: 40px;
  }
  @media (max-width: 680px) {
    padding-left: 16px;
  }
}
.scrolled{
  .previewInfo{
    top: 60px;
  }
}
</style>
